import useSWR, { SWRResponse } from 'swr';
import { getHRCalendarEvent } from '../../../providers/api/hr/hrProvider';
import { HRCalendarEvent } from '../../../providers/api/dtos';
import { API_HR_PATH } from '../../../providers/api/api';

export const getHRCalendarEventRid = (id: NonNullable<HRCalendarEvent['id']>) => [API_HR_PATH, 'calendar-events', id];

export default function useHRCalendarEvent(id?: NonNullable<HRCalendarEvent['id']>): SWRResponse<HRCalendarEvent> {
  const key = id ? getHRCalendarEventRid(id) : null;

  return useSWR(key, () => getHRCalendarEvent(id!));
}
